import React from 'react';

export default ({ error }) => <div className="upload-error">{error}</div>;
